import React, { useCallback, useEffect, useRef, useState } from "react";
import { RenderContent } from "@smartfire/gutenberg-react";
import { Alert as MuiAlert, AlertTitle } from '@material-ui/lab';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
    loading: {
        display: 'flex',
        justifyContent: "center"
    },
}));
function Alert({ formStatus, content, formErrors }) {
    const style = useStyles();
    if (content === false) {
        return React.createElement(MuiAlert, { severity: "error" },
            React.createElement(AlertTitle, null, "Erreur"),
            "Erreur lors de l'affichage du formulaire");
    }
    else {
        switch (formStatus) {
            case "sending":
                return React.createElement("div", { className: style.loading + " glueFormLoading" },
                    React.createElement(CircularProgress, null));
            case true:
                return React.createElement(MuiAlert, { severity: "success" },
                    React.createElement(AlertTitle, null, "Valid\u00E9"),
                    "Votre message a bien \u00E9t\u00E9 envoy\u00E9 !");
            case false:
                return React.createElement(MuiAlert, { severity: "error" },
                    React.createElement(AlertTitle, null, "Erreurs lors de l'envoi du formulaire"),
                    React.createElement("ul", null, formErrors && formErrors.map((element, index) => React.createElement("li", { key: index }, element))));
        }
    }
    return null;
}
function RenderLegacyForm({ slug, className = null, children = null }) {
    const style = useStyles();
    const [content, setContent] = useState("");
    const [formStatus, setFormStatus] = useState();
    const [formErrors, setFormErrors] = useState();
    const form = useRef();
    //Handle submission of the form
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        setFormStatus("sending");
        let fieldsData = {};
        let submitData = new FormData();
        let data = new FormData(e.target);
        for (let pair of data.entries()) {
            //File Field
            if (pair[1] instanceof File) {
                submitData.append("file", pair[1]);
                fieldsData[pair[0]] = { reference: "urn:formfile:" + pair[1].name };
            }
            else {
                fieldsData[pair[0]] = { value: pair[1] };
            }
        }
        //Make glue Smartforms send
        submitData.append("fields", JSON.stringify(fieldsData));
        glue.api.post("/api/forms/submit/" + slug, submitData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then((data) => {
            var _a, _b;
            if ((_a = data.data) === null || _a === void 0 ? void 0 : _a.success) {
                setFormStatus(true);
                (_b = form.current) === null || _b === void 0 ? void 0 : _b.reset();
            }
        }).catch((e) => {
            var _a, _b, _c;
            setFormStatus(false);
            setFormErrors((_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors);
            console.error(e);
            console.error((_c = e.response) === null || _c === void 0 ? void 0 : _c.data);
        });
    }, [slug, setFormErrors, setFormStatus]);
    //Get content of form to render
    useEffect(() => {
        if (slug) {
            glue.api.get("/api/forms/public/definitions/" + slug).then((data) => {
                var _a;
                if (data.status === 200) {
                    setContent((_a = data.data.content) === null || _a === void 0 ? void 0 : _a.value);
                }
                else {
                    setContent(false);
                }
            }).catch((e) => {
                console.error(e);
                setContent(false);
            });
        }
    }, [slug, fetch, setContent, form]);
    if (content) {
        return React.createElement("form", { ref: form, className: className, method: "post", onSubmit: handleSubmit },
            React.createElement(Alert, { content: content, formStatus: formStatus, formErrors: formErrors }),
            React.createElement(RenderContent, { content: content }),
            children);
    }
    else if (content === false) {
        return React.createElement(Alert, { content: content, formStatus: formStatus, formErrors: formErrors });
    }
    else {
        return React.createElement("div", { className: style.loading + " glueFormLoading" },
            React.createElement(CircularProgress, null));
    }
}
export default RenderLegacyForm;
//# sourceMappingURL=RenderLegacyForm.js.map